export const BLOGS_CONSTS = {
    GET_BLOG_TYPES: "GET_BLOG_TYPES",
    GET_BLOGS: "GET_BLOGS",
    GET_SINGLE_BLOG: "GET_SINGLE_BLOG",
};
